import React, { Fragment } from 'react';
import { useTranslation } from "react-i18next";
import banner from '../../assets/images/img-banner.jpg';

const University = () =>{

    const { t } = useTranslation();

    return(
        <Fragment>
            <section className="text-center py-3">
                <h2 className="text-3xl font-bold pt-4 lg:pt-0">{t("homologate.label")}</h2>
            </section>
            <section className="flex flex-row justify-around items-center max-w-7xl mx-auto my-2 py-5 bg-gray-50">
                <div className="w-3/6 text-justify">
                    <p className="font-sans text-base py-4">{t("homologate.description")}</p>
                </div>
                <div className="w-2/6">
                    <img
                        className="object-cover overflow-hidden rounded-md"
                        src={banner}
                        alt="Banner Universidad de los Andes"
                    />    
                </div>
                
            </section>
        </Fragment>
    )
}

export default University;